import { Button, QRCode } from 'antd';
import React from 'react';
import { useState } from 'react';
import s from './index.module.scss';
import { Col } from 'reactstrap';

const downloadQRCode = () => {
    const canvas = document.getElementById('myqrcode')?.querySelector('canvas');
    if (canvas) {
        const url = canvas.toDataURL();
        const a = document.createElement('a');
        a.download = 'QRCode.svg';
        a.href = url;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
};

export const QR = () => {
    const [picture, setPicture] = useState(null);
    const [QR, setQR] = useState(false);
    const handlePicture = (e) => {
        let fileReader = new FileReader();
        fileReader.onload = function () {
            setPicture(fileReader.result);
        };
        fileReader.readAsDataURL(e.target.files[0]);
    };
    const location = window.location.origin;

    return (
        <Col xs={12} className={'mt-3'}>
            <label className={`${s.card}`} htmlFor={'input_file'}>
                <input
                    type={'file'}
                    id={'input_file'}
                    name={'file'}
                    accept="image/png, image/jpeg, image/jpg, image/svg"
                    onChange={handlePicture}
                />
                {picture ? (
                    <p>Загружено</p>
                ) : (
                    <>
                        <p className={s.card_title}>Загрузить логотип</p>
                        <p>jpeg, jpg, svg, png</p>
                    </>
                )}
            </label>
            <div onClick={() => setQR(true)} className="pointer">
                Сгенерировать
            </div>
            {QR && (
                <div id="myqrcode">
                    <QRCode
                        errorLevel="H"
                        value={location}
                        icon={picture ? picture : null}
                    />
                    <Button
                        type="default"
                        onClick={downloadQRCode}
                        className={`${s.btn} mt-2`}
                    >
                        Download
                    </Button>
                </div>
            )}
        </Col>
    );
};
